// extracted by mini-css-extract-plugin
export default {"formGroup":"styles_formGroup__XPTcY","formLabel":"styles_formLabel__O7W3Q","formInput":"styles_formInput__cP4jV"};